export default __webpack_public_path__ + "static/media/mobileAppIcon.bb0e69e6.svg";